export default {
  name: 'gmk-plum',
  override: {
    KC_ENT: 'accent'
  }
};
